import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr2003',
    ecrans: ['00-2']
});
